import { ArticleDataModel, ArticleModel } from '@/components/Article/article.model';

export const ArticleData: ArticleDataModel = {
    about: new Map([
        [
            'whats-in-a-name-from-galahad-to-mars-task-force',
            new ArticleModel(
                'Whats in a Name? From Galahad to MARS Task Force',
                '/about/whats-in-a-name-from-galahad-to-mars-task-force'
            )
        ],
        [
            'men-of-the-marauders',
            new ArticleModel('Men of the Marauders', '/about/men-of-the-marauders')
        ],
        [
            'congressional-gold-medal-campaign',
            new ArticleModel(
                'Congressional Gold Medal Campaign',
                '/about/congressional-gold-medal-campaign'
            )
        ],
    ]),
    events: new Map([
        ['past-reunions', new ArticleModel('Past Reunions', '/events/past-reunions')]
    ]),
    photos: new Map([
        ['then-and-now', new ArticleModel('Then and Now', '/photos/then-and-now')],
        [
            'marauder-photo-albums',
            new ArticleModel('Marauder Photo Albums', '/photos/marauder-photo-albums')
        ]
    ]),
    links: new Map([
        ['burman-news', new ArticleModel('Burman News', '/links/burman-news')],
        [
            'websites-books-videos',
            new ArticleModel('Websites/Books/Videos', '/links/websites-books-videos')
        ],
        [
            'inspiration-and-tributes',
            new ArticleModel('Inspiration & Tributes', '/links/inspiration-and-tributes')
        ],
        [
            'how-to-request-military-medals',
            new ArticleModel(
                'How to Request Military Medals',
                '/links/how-to-request-military-medals'
            )
        ]
    ])
};
